// extracted by mini-css-extract-plugin
export var paragraph = "TextImage-module--paragraph--rTo04";
export var text = "TextImage-module--text--kRRqq";
export var title = "TextImage-module--title--VMF8m";
export var title__border = "TextImage-module--title__border--InCTn";
export var wrapper = "TextImage-module--wrapper--Fwc4p";